<template>
  <div>
    <div class="group_date_time_picker_layer">
      <div :class="{ loading: loading }" class="group_date_picker_layer">
        <date-picker v-model="date" type="date" format="MM/DD/YYYY" title-format="DD/MM/YYYY"
          time-title-format="DD/MM/YYYY" valueType="YYYY-MM-DD" class="calendar-picker-layer" placeholder="MM/DD/YYYY"
          @change="handleChangeDate"></date-picker>
        <div v-if="loading" class="group_date_picker_layer_loading">
          <font-awesome-icon icon="spinner" class="fa-spin" />
        </div>
      </div>
      <div v-if="isDisplaySelectTime" class="group_date_picker_layer">
        <date-picker
          class='calendar-picker-layer'
          v-model="time"
          type='time'
          placeholder='Select time'
          default-value=''
          valueType='HH:mm:ss'
          @change="handleChangeTime"
        ></date-picker>
        <div v-if="loading" class="group_date_picker_layer_loading">
          <font-awesome-icon icon="spinner" class="fa-spin" />
        </div>
      </div>
    </div>
    <div class="group_date_picker_layer_mobile">
      <div class="group_date_time_picker_layer">
        <div class="group_date_picker_layer_mobile__btn" @click="handleOpenData">
          <div>
            {{ formatDate(date) }}
          </div>
          <div>
            <div v-if="loading" class="group_date_picker_layer_loading">
              <font-awesome-icon icon="spinner" class="fa-spin" />
            </div>
            <v-icon v-else style="width: 18px" name="calendar"></v-icon>
          </div>
        </div>
        <div v-if="isDisplaySelectTime" class="group_date_picker_layer_mobile">
          <date-picker
            class='calendar-picker-layer'
            v-model="time"
            type='time'
            placeholder='Select time'
            default-value=''
            valueType='HH:mm:ss'
            @change="handleChangeTime"
          ></date-picker>
          <div v-if="loading" class="group_date_picker_layer_loading">
            <font-awesome-icon icon="spinner" class="fa-spin" />
          </div>
        </div>
      </div>
      <div v-if="openSelectDate" class="group_date_picker_layer_mobile__model">
        <date-picker v-model="dateMobile" type="date" title-format="DD/MM/YYYY" format="MM/DD/YYYY"
          time-title-format="DD/MM/YYYY" valueType="YYYY-MM-DD" class="calendar-picker-layer"
          popup-class="calendar-picker-layer-mobile" placeholder="MM/DD/YYYY" :open="true"></date-picker>
        <div class="calendar-picker-layer-footer-mobile">
          <button type="button" @click="hideDateMobile" class="btn Abn-btn-cancel">Cancel</button>
          <button type="button" class="btn Abn-btn-apply" @click="handleApplyDateMobile">Apply</button>
        </div>
      </div>
    </div>
    <div v-if="moonColors.length > 1" class="moon-color-switch">
      <div class="label_lyric_choose">
        <label class="formulate-input-label">Choose moon color</label>
      </div>
      <ul class="moon-color-switch-list">
        <li
          v-for="(entry, index) in moonColors"
          :key="entry.id || index"
          :class="{ active: isActiveMoonColor(entry) }"
        >
          <div
            :style="{ backgroundColor: entry.color }"
            @click="selectMoonColor(entry)"
          />
        </li>
      </ul>
    </div>
    <div class="input-group-date-moon" v-if="isDisplaySearchLocation">
      <div class="label_lyric_choose">
        <label class="formulate-input-label"
          >Enter a location</label
        >
      </div>
      <div class="group-date-moon" :class="{
        'loading': loading
      }">
        <gmap-autocomplete
          placeholder="Enter the location"
          class="Abn-form-search-map-moon"
          @place_changed="handleChangeGmap"
          @input="handleChancheLocation"
          ref="locationTextRef"
          :options="{fields: ['geometry', 'formatted_address', 'address_components']}"
        >
        </gmap-autocomplete>
        <svg v-if="!loading" class="group-date-moon-icon" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="-5.0 -10.0 110.0 110.0">
          <path d="m22.309 49.242 25.059 42.953c0.55859 0.96484 1.5898 1.5547 2.7031 1.5547 1.1172 0 2.1484-0.58984 2.707-1.5547l25.059-42.953c2.6719-4.5312 3.5586-9.7734 3.5586-15.375 0-16.953-14.02-30.742-31.324-30.742-17.301 0-31.32 13.789-31.32 30.742 0 5.6016 0.88672 10.844 3.5586 15.375zm27.762-30.492c-8.6445 0-15.66 7-15.66 15.625s7.0156 15.625 15.66 15.625c8.6445 0 15.664-7 15.664-15.625s-7.0195-15.625-15.664-15.625z" fill-rule="evenodd"/>
        </svg>
        <div v-else class="group_map_picker_layer_loading">
          <font-awesome-icon icon="spinner" class="fa-spin" />
        </div>
        <div v-if="address" @click="handleResetLocaltion" class="group-date-moon-xmax">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" height="10" width="10" version="1.1" id="Capa_1" viewBox="0 0 460.775 460.775" xml:space="preserve">
            <path d="M285.08,230.397L456.218,59.27c6.076-6.077,6.076-15.911,0-21.986L423.511,4.565c-2.913-2.911-6.866-4.55-10.992-4.55  c-4.127,0-8.08,1.639-10.993,4.55l-171.138,171.14L59.25,4.565c-2.913-2.911-6.866-4.55-10.993-4.55  c-4.126,0-8.08,1.639-10.992,4.55L4.558,37.284c-6.077,6.075-6.077,15.909,0,21.986l171.138,171.128L4.575,401.505  c-6.074,6.077-6.074,15.911,0,21.986l32.709,32.719c2.911,2.911,6.865,4.55,10.992,4.55c4.127,0,8.08-1.639,10.994-4.55  l171.117-171.12l171.118,171.12c2.913,2.911,6.866,4.55,10.993,4.55c4.128,0,8.081-1.639,10.992-4.55l32.709-32.719  c6.074-6.075,6.074-15.909,0-21.986L285.08,230.397z"/>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { URL_API_CREATE_CUSTOM_MOON_PHASE, XKEY_API_CREATE_CUSTOM_MOON_PHASE } from '../../config'
import { mapGetters, mapMutations } from 'vuex'
import { get } from 'lodash'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import CalendarCanvas from '../Render/CalendarCanvas.vue'
import axios from 'axios'
import tzlookup from 'tz-lookup'
import { getActiveMoonColorEntry } from '@/helper/helper'
export default {
  name: 'imageMoonPhase',
  components: {
    DatePicker,
    CalendarCanvas
  },
  data() {
    const stored = get(this.personalized(), `${this.artwork.id}.${this.layer.id}`) || {}
    const activeEntry = getActiveMoonColorEntry(this.layer, stored.moon_color_id, stored.moon_color)
    const initialMoonColor = stored.moon_color
      || get(this.configsMoonPhase, 'render.moon_color')
      || get(activeEntry, 'color', "#07c307");
    return {
      date: null,
      dateMobile: null,
      time: null,
      timeMobile: null,
      loading: false,
      openSelectDate: false,
      configsBodyRender: {},
      location: null,
      address: null,
      timezone: null,
      moon_color: initialMoonColor,
      moon_color_id: get(activeEntry, 'id', null),
      renderRequestId: 0
    }
  },
  props: {
    context: {
      type: Object,
      required: true
    },
    artwork: {
      type: Object,
      required: true
    },
    aspectRatio: {
      type: Number,
      default() {
        return 1
      }
    },
    configsMoonPhase: {
      type: Object,
      required: true
    },
    name: {
      type: String,
      default() {
        return null
      }
    },
    layer: {
      type: Object,
      required: true
    },
  },
  computed: {
    localStorageName() {
      return this.context.name + '_' + this.product().id
    },
    isDisplaySelectTime(){
      const {layer} = this;
      return get(layer, 'isDisplaySelectTime', false)
    },
    moonPhase_ParentID(){
      const {layer} = this;
      return get(layer, 'moonPhase_ParentID', null)
    },
    isDisplaySearchLocation(){
      const {layer} = this;
      return get(layer, 'isDisplaySearchLocation', true)
    },
    moonColors() {
      return get(this.layer, 'MoonColors', [])
    },
    selectedMoonColor() {
      return this.moon_color
    },
    selectedMoonColorId() {
      return this.moon_color_id
    }
  },
  watch: {
    context(v) {
      const { date, address, moon_color, moon_color_id, location, time, timezone } = v.model || {}
      if (date) {
        this.date = date
      }
      if(address){
        if(this.$refs.locationTextRef){
          this.$refs.locationTextRef.$el.value = address;
        }
        this.address = address;
      }
      if (moon_color && moon_color !== this.moon_color) {
        this.moon_color = moon_color
      }
      if (moon_color_id && moon_color_id !== this.moon_color_id) {
        this.moon_color_id = moon_color_id
      }
      if(location){
        this.location = location;
      }
      if(time){
        this.time = time;
      }
      if(timezone){
        this.timezone = timezone;
      }
    },
    moon_color(){
      this.renderImage()
    }
  },
  mounted() {
    const {formatted_address} = this.layer;
    if(formatted_address && this.$refs.locationTextRef){
      this.$refs.locationTextRef.$el.value = formatted_address;
      this.address = formatted_address;
    }
  },
  created() {
    const { date, location, time, timezone } = this.configsMoonPhase;
    if (date) {
      this.date = date
    }
    if(location){
      this.location = location || null;
    }
    if(time){
      this.time = time || null;
    }
    if(timezone){
      this.timezone = timezone;
    }
  },
  methods: {
    ...mapGetters(['product', 'platform', 'getCartData', 'isSaveLocalstorage', 'personalized']),
    ...mapMutations([
      'setCartDataByKey',
      'setMessageError',
      'setLoadingForm',
      'setIsSaveLocalstorage',
      'setImageLoadings'
    ]),
    isActiveMoonColor(entry) {
      return entry.id ? entry.id === this.moon_color_id : entry.color === this.moon_color;
    },
    selectMoonColor(entry) {
      this.moon_color_id = entry.id || null;
      this.moon_color = entry.color;
      this.context.model = { ...(this.context.model || {}), moon_color: entry.color, moon_color_id: this.moon_color_id };
    },
    handleResetLocaltion(){
      this.$refs.locationTextRef.$el.value = null;
      this.address = null
    },
    handleChancheLocation(v){
      const value = v.target.value;
      if(!value){
        this.address = null;
      }
    },
    formatDate(date) {
      if (!date) {
        return "Select date";
      }
      const dayArray = date.split('-');
      const [year,month,  day ] = dayArray;
      return `${month}/${day}/${year}`;;
    },
    handleOpenData(v) {
      this.dateMobile = this.date;
      this.openSelectDate = true;
    },
    hideDateMobile() {
      this.openSelectDate = false;
    },
    handleApplyDateMobile() {
      const { dateMobile } = this;
      this.date = dateMobile;
      this.renderImage();
      this.openSelectDate = false;
    },
    handleChangeGmap(loc){
      this.location = {
        latitude: loc.geometry.location.lat(),
        longitude: loc.geometry.location.lng()
      }
      this.timezone = tzlookup(loc.geometry.location.lat(), loc.geometry.location.lng());
      this.address = loc.formatted_address || null;
      this.renderImage()
    },
    handleChangeDate(date){
       if (!date) return
       this.date = date;
       this.renderImage()
    },
    handleChangeTime(time){
      this.time = time;
      this.renderImage()
    },
    renderCoordinatesMap(lat, lng){
      if(!(lat && lng)) return;
      let iconLat = Number(lat) < 0 ? 'S' : 'N';
      let iconLng = Number(lng) < 0 ? 'W' : 'E';
      return Math.abs(lat).toFixed(4) + '° ' + iconLat + ', ' + Math.abs(lng).toFixed(4)  + '° ' + iconLng;
    },
    handleChangeTextChild(data){
      const {renderCoordinatesMap, address, moonPhase_ParentID, formatDate} = this
      const {date, location} = data
      const emitData = {
        id: moonPhase_ParentID,
        date: formatDate(date),
        coordinates: renderCoordinatesMap(location.latitude, location.longitude),
        address
      }
      this.$emit('changeTextMoonPhase', emitData);
    },
    async renderImage() {
      const {date, location, configsMoonPhase, localStorageName, context, time, timezone, address, moon_color, moon_color_id } = this;
      if (!date) return
      this.setLoadingForm(true)
      const requestId = ++this.renderRequestId;
      this.loading = true;
      this.openSelectDate = false;
      const body = {
        ...configsMoonPhase,
        date,
        location,
        time,
        timezone,
        render: {
          ...configsMoonPhase.render,
          moon_color,
          width: 2000,
          height: 2000
        }
      }
      this.handleChangeTextChild(body)
      const req = await axios.post(URL_API_CREATE_CUSTOM_MOON_PHASE, { ...body }, {
        headers: {
          'X-ABN-KEY': XKEY_API_CREATE_CUSTOM_MOON_PHASE,
          'content-type': 'application/json'
        }
      }).then(res => {
          return get(res, 'data.render', false);
      }).catch(() => {
          return false;
      });
      if (requestId !== this.renderRequestId) {
        return;
      }
      if(!req){
        this.setLoadingForm(false)
        this.loading = false;
        return;
      }
      const file = {
        id: this.context.name,
        key: req.png_file.replace(/^\//, ''),
        address: address,
        date,
        location,
        time,
        timezone,
        moon_color,
        moon_color_id
      }
      this.context.model = file

      this.setIsSaveLocalstorage(true);
      this.setCartDataByKey({
        key: localStorageName,
        name: context.label,
        value: {
          configsMoonPhase: { ...body }
        }
      });
      this.setLoadingForm(false)
      this.loading = false;
    },
  }
}
</script>

<style>
ul.moon-color-switch-list {
  margin: 0 0 10px;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

ul.moon-color-switch-list li {
  list-style: none;
  cursor: pointer;
  margin: 0 !important;
}

ul.moon-color-switch-list li > div {
  width: 32px;
  height: 32px;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 2px 1px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s;
}

ul.moon-color-switch-list li.active > div {
  box-shadow: 0 0 0 2px #fff, 0 0 0 4px #686b5a;
}

.mx-calendar * {
  font-family: system-ui;
  font-size: 14px;
}

.calendar-picker-layer {
  width: 100%;
}

.calendar-picker-layer input.mx-input {
  height: 40px;
  font-size: 16px;
  color: #555;
  font-weight: 500;
  font-family: system-ui;
  margin: 0 !important;
  border-radius: 3px;
  outline: none;
  /* box-shadow: none; */
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, .1) !important;
}

tr.mx-date-row td {
  border: none !important;
}

tr.mx-date-row td div {
  display: flex;
  align-items: center;
  justify-content: center;
}

.mx-calendar-content .cell.active {
  color: #fff;
  background-color: #686b5a;
  border-radius: 5px;
  font-weight: 800;
}

.mx-table thead tr th {
  font-weight: 700;
  text-align: center;
  border: none !important;
}

.group_date_time_picker_layer{
  display: flex;
  justify-content: center;
  gap: 5px
}

.group_date_picker_layer {
  position: relative;
  width: 100%;
}

.group_date_picker_layer_loading {
  position: absolute;
  top: 0;
  background: #0000001c;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 8px;
  border-radius: 5px;
  cursor: not-allowed;
}

.group_date_picker_layer.loading i.mx-icon-calendar {
  display: none;
}

table.mx-table.mx-table-year tr td,
table.mx-table.mx-table-month tr td {
  text-align: center;
  border: none !important;
}

.group_date_picker_layer_mobile {
  display: none;
}

.Abn-form-search-map-moon{
  width: 100%;
  outline: none;
  padding: 7px;
  border: 1px solid #ccc;
  border-radius: 5px;
  transition: 0.7s;
  padding-left: 30px;
  padding-right: 35px;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, .1) !important;
}
.Abn-form-search-map-moon:focus{
  border: 1px solid  #686b5a;
}

.input-group-date-moon, .moon-color-switch{
  margin-top: 10px;
}


.group-date-moon{
  position: relative;
}

.group-date-moon.loading{
  opacity: 0.6;
  pointer-events: none;
}

.group-date-moon-icon{
  position: absolute;
  width: 21px;
  height: 21px;
  fill: #ccc;
  top: 10px;
  left: 6px;
  transition: 0.6s;
}

.group-date-moon-xmax{
  width: 40px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  max-width: 40px;
  min-width: 40px;
  max-height: 40px;
  min-height: 40px;
  position: absolute;
  top: 0px;
  right: 0px;
  transition: 0.6s;
}

.group-date-moon-xmax svg{
  fill:"#464646";
}

.group-date-moon-xmax:hover svg{
  transition: 0.6s;
  fill:"#d80000";
}

.group_map_picker_layer_loading{
  position: absolute;
  width: 21px;
  height: 21px;
  fill: #ccc;
  top: 8px;
  left: 8px;
  transition: 0.6s;
}

.group_map_picker_layer_loading svg *{
   fill: #686b5a !important;
}

.Abn-form-search-map-moon:focus ~ .group-date-moon-icon{
  fill: #686b5a;
  transition: 0.6s;
}

@media (max-width:641px) {
  .group_date_picker_layer {
    display: none !important;
  }

  .group_date_picker_layer_mobile {
    display: block;
    width: 100%;
    position: relative;
  }

  .group_date_picker_layer_mobile__btn {
    width: 100%;
    height: 40px;
    font-size: 16px;
    color: #555;
    font-weight: 500;
    font-family: system-ui;
    margin: 0 !important;
    border-radius: 3px;
    outline: none;
    border: 1px solid #ccc;
    display: flex;
    padding: 10px;
    align-items: center;
    box-shadow: none !important;
    line-height: 0 !important;
    background: #fff;
    position: relative;
    justify-content: space-between;
    margin: 0px !important;
            box-shadow: inset 0 1px 2px rgba(0, 0, 0, .1) !important;
  }

  .group_date_picker_layer_mobile__model {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    padding: 10px;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .calendar-picker-layer-mobile {
    position: absolute;
    left: 10px !important;
    right: 10px !important;
    box-shadow: none !important;
    border: none;
  }

  .calendar-picker-layer-mobile .mx-calendar.mx-calendar-panel-date,
  .calendar-picker-layer-mobile .mx-calendar {
    width: 100% !important;
  }

  button.btn.Abn-btn-cancel {
    background: #7b7b7e !important;
    color: white !important;
    font-weight: 600 !important;
    width: 49%;
    float: left;
    font-weight: 700 !important;
  }

  button.btn.Abn-btn-apply {
    background: none 0% 0% / auto repeat scroll padding-box border-box rgb(33 171 43) !important;
    color: white !important;
    font-weight: 600 !important;
    width: 49%;
    float: left;
    font-weight: 700 !important;
  }

  .calendar-picker-layer-footer-mobile {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .group_date_picker_layer_mobile__model .calendar-picker-layer.mx-datepicker .mx-input-wrapper {
    display: none;
  }

  .calendar-picker-layer-footer-mobile button {
    margin: 0 !important;
    border-radius: 3px;
    font-family: system-ui;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Formulate/ImageMoonPhase.vue